module.exports = __webpack_public_path__ + "img/fabriqblog-original-480.e892ca7c.webp";